; (function () {
    if ($L) {
        $L.typeWriter = {};
        $L.typeWriter.enable = function (typeWriterObj) {
            var type = typeWriterObj.type;
            var speed = typeWriterObj.speed;
            var text = typeWriterObj.text;
            var htmlSnippet = typeWriterObj.htmlSnippet;
            var container = typeWriterObj.container;
            if (container) {
                // Container found, proceed with enabling typewriter effect
                if (type === 'html') {
                    enableHTML(container, htmlSnippet, speed);
                }
                else if (type === 'text') {
                    enableText(container, text, speed);
                }
            }
        };

        function enableText(container, text, speed) {
            var fullText = text || container.innerText || '';
            if (!fullText) {
                console.error("No text provided for typewriter effect.");
                return;
            }
            speed = speed || 10;
            container.textContent = '';
            var index = 0;
            var startTime = Date.now();
            var buffer = '';

            function typeWriter() {
                var elapsed = Date.now() - startTime;
                var expectedIndex = Math.floor(elapsed / speed);
                while (index < expectedIndex && index < fullText.length) {
                    buffer += fullText.charAt(index);
                    index++;
                }
                container.textContent = buffer; // Only one DOM update per tick
                if (index < fullText.length) {
                    setTimeout(typeWriter, speed);
                }
            }
            typeWriter();
        }

        function enableHTML(container, htmlSnippet, speed) {
            speed = speed || 10;

            // Clear the container first
            container.innerHTML = '';

            // Create a temporary container to parse the HTML
            var tempContainer = document.createElement('div');
            tempContainer.innerHTML = htmlSnippet || '';

            function getTextNodes(node, nodes) {
                if (node.nodeType === 3) {
                    nodes.push(node);
                } else {
                    for (var i = 0; i < node.childNodes.length; i++) {
                        getTextNodes(node.childNodes[i], nodes);
                    }
                }
            }
            var textNodes = [];
            getTextNodes(tempContainer, textNodes);

            var originals = [];
            for (var i = 0; i < textNodes.length; i++) {
                originals.push(textNodes[i].nodeValue);
            }
            var nodeIndex = 0, charIndex = 0, totalIndex = 0;
            var totalLength = 0, nodeLengths = [];
            for (var i = 0; i < originals.length; i++) {
                nodeLengths[i] = originals[i].length;
                totalLength += originals[i].length;
            }

            // Clone the structure but with empty text
            container.innerHTML = tempContainer.innerHTML;

            // Now get the actual text nodes from the real container
            var realTextNodes = [];
            getTextNodes(container, realTextNodes);

            // Clear all text content
            for (var i = 0; i < realTextNodes.length; i++) {
                realTextNodes[i].nodeValue = '';
            }

            var startTime = Date.now();

            function revealNextChar() {
                var elapsed = Date.now() - startTime;
                var expectedTotalIndex = Math.floor(elapsed / speed);
                var updated = false;

                while (totalIndex < expectedTotalIndex && nodeIndex < realTextNodes.length) {
                    if (charIndex < nodeLengths[nodeIndex]) {
                        realTextNodes[nodeIndex].nodeValue += originals[nodeIndex].charAt(charIndex);
                        charIndex++;
                        totalIndex++;
                        updated = true;
                    } else {
                        nodeIndex++;
                        charIndex = 0;
                    }
                }

                if (totalIndex < totalLength) {
                    setTimeout(revealNextChar, speed);
                }
            }
            revealNextChar();
        }

    }
})();